import { render, staticRenderFns } from "./MainProjectForm.vue?vue&type=template&id=8fd5c4c8"
import script from "./MainProjectForm.vue?vue&type=script&lang=js"
export * from "./MainProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports